import { useState } from "react";
import { Button } from "@/components/ui/button";
import { RefreshCw, CheckCircle, AlertCircle } from "lucide-react";
import { syncStandings } from "@/lib/edgeFunctions";
import { useToast } from "@/hooks/use-toast";

interface InitialSyncButtonProps {
  onSyncComplete?: () => void;
  className?: string;
}

export function InitialSyncButton({ onSyncComplete, className }: InitialSyncButtonProps) {
  const [loading, setLoading] = useState(false);
  const [synced, setSynced] = useState(false);
  const { toast } = useToast();

  const handleInitialSync = async () => {
    try {
      setLoading(true);
      setSynced(false);
      
      // All league API IDs
      const allLeagueApiIds = [78, 71, 140, 61, 88, 39, 135, 94, 2, 848, 3, 119, 179, 203, 40, 79, 307, 95];
      
      await syncStandings(allLeagueApiIds, 2025);
      
      setSynced(true);
      
      toast({
        title: "Sync Inicial Concluído",
        description: "Todas as classificações foram sincronizadas com sucesso!",
      });
      
      onSyncComplete?.();
      
    } catch (error) {
      console.error('Error in initial sync:', error);
      toast({
        title: "Erro no Sync",
        description: "Erro ao sincronizar classificações. Tente novamente.",
        variant: "destructive"
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      onClick={handleInitialSync}
      disabled={loading || synced}
      variant={synced ? "default" : "outline"}
      className={className}
    >
      {loading ? (
        <>
          <RefreshCw className="mr-2 h-4 w-4 animate-spin" />
          Sincronizando...
        </>
      ) : synced ? (
        <>
          <CheckCircle className="mr-2 h-4 w-4" />
          Sincronizado
        </>
      ) : (
        <>
          <RefreshCw className="mr-2 h-4 w-4" />
          Sync Inicial das Classificações
        </>
      )}
    </Button>
  );
}